export function makeHyphenPhoneNumber(inputString) {
  let str = inputString.replaceAll('-', '');

  const numbers = str.substring(0, 11);
  const firstPart = numbers.substring(0, 3); // 처음 2글자
  const secondPart = numbers.substring(3, 7); // 3번째부터 7번째까지의 글자
  const thirdPart = numbers.substring(7, 11);
  // 원하는 형식으로 문자열을 생성
  if (thirdPart) {
    return `${firstPart}-${secondPart}-${thirdPart}`;
  } else if (secondPart) {
    return `${firstPart}-${secondPart}`;
  } else {
    return `${firstPart}`;
  }
}
export function makeHyphenBusinessNumber(inputString) {
  let str = inputString.replaceAll('-', '');

  const numbers = str.substring(0, 10);
  const firstPart = numbers.substring(0, 3); // 처음 2글자
  const secondPart = numbers.substring(3, 5); // 3번째부터 7번째까지의 글자
  const thirdPart = numbers.substring(5, 10);
  // 원하는 형식으로 문자열을 생성
  if (thirdPart) {
    return `${firstPart}-${secondPart}-${thirdPart}`;
  } else if (secondPart) {
    return `${firstPart}-${secondPart}`;
  } else {
    return `${firstPart}`;
  }
}

export function validateBusinessNumber(input) {
  const regex = /^\d{10}$/;
  return regex.test(input);
}

export function hasNullOrUndefinedValue(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      // null 또는 undefined가 있는 경우
      if (value === null || value === undefined || value === '') {
        return true;
      }

      // 객체 내의 하위 객체에 대해서 재귀적으로 체크
      if (typeof value === 'object' && hasNullOrUndefinedValue(value)) {
        return true;
      }
    }
  }

  return false;
}

export function validatePassword(password) {
  // 8~20자, 영문/숫자/특수문자 중 2가지 이상 조합
  const regex =
    /^(?=.{8,20}$)(?:(?=.*[A-Za-z])(?=.*\d)|(?=.*[A-Za-z])(?=.*[~!@#$%^&*()_+])|(?=.*\d)(?=.*[~!@#$%^&*()_+]))[A-Za-z\d~!@#$%^&*()_+]+$/;

  return regex.test(password);
}

export const validateEmail = (email) => {
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phoneNumber) => {
  const removeHyphenPhone = phoneNumber.replaceAll('-', '');
  const phoneRegex = /^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}/;
  return phoneRegex.test(removeHyphenPhone);
};

export const convertToHyphenCase = (jsonObject) => {
  try {
    // 변환된 JSON 객체 생성
    const transformedObject = {};
    for (const key in jsonObject) {
      if (jsonObject.hasOwnProperty(key)) {
        // 대문자를 소문자로 변환하고 하이픈 추가
        const newKey = key.replace(
          /[A-Z]/g,
          (match) => `-${match.toLowerCase()}`,
        );
        transformedObject[newKey] = jsonObject[key];
      }
    }

    // 변환된 JSON 객체를 문자열로 반환
    return transformedObject;
  } catch (error) {
    console.error('Error converting JSON:', error);
    return null;
  }
};

export const uniqueByKey = (arr, key) => {
  // 중복을 제거한 값을 담을 새로운 배열 생성
  const uniqueArray = [];

  // 중복을 제거할 때 사용할 Map 객체 생성
  const map = new Map();

  // 배열을 순회하면서 특정 키의 값이 중복되는 경우 제거
  for (const item of arr) {
    if (!map.has(item[key])) {
      map.set(item[key], true); // 키의 값을 Map에 추가
      uniqueArray.push(item); // 중복되지 않는 경우 새로운 배열에 추가
    }
  }

  return uniqueArray;
};

export function getRowNumber(pageMeta, rowIndex) {
  if (pageMeta === undefined || pageMeta === null)
    throw Error(`getRowNumber() :: pageMeta가 필요합니다.`);
  if (rowIndex === undefined || rowIndex === null || rowIndex < 0)
    throw Error(`getRowNumber() :: rowIndex가 필요합니다.`);
  return pageMeta.total - (pageMeta.current - 1) * pageMeta.pageSize - rowIndex;
}

/**
 * innerHTML에서 가져온 문자열을 input.value에 안전하게 넣을 수 있는 평문으로 변환
 * - 태그 제거
 * - HTML 엔티티(&amp;, &lt; 등) 디코딩
 * - &nbsp; → 일반 공백 치환, 과도한 공백 정리
 */
export function htmlToInputValue(html) {
  if (html == null) return '';
  // 줄바꿈 보존(필요 없으면 이 줄 삭제)
  const withBreaks = String(html).replace(/<\s*br\s*\/?>/gi, '\n');

  const doc = new DOMParser().parseFromString(withBreaks, 'text/html');
  let text = doc.body.textContent || '';
  // NBSP → space
  text = text.replace(/\u00A0/g, ' ');
  // 공백 정리(필요 시)
  return text.replace(/\s+/g, ' ').trim();
}
